import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MdArrowForward } from 'react-icons/md';
import logo from '../images/logo.png';
// import { useAccount } from '../context/AccountContext';
import { useDispatch, useSelector } from 'react-redux';
import { setCredentials, logOut } from '../features/auth/authSlice';
import { clearAccountData, setAccountId } from '../features/account/accountSlice';
import { APP_BASE_URL } from '../config/api';
import useActivityStatus from '../hooks/useActivityStatus';

const ACTIVITY_TIMEOUT_ENV = process.env.REACT_APP_ACTIVITY_TIMEOUT || 120;
const ACTIVITY_TIMEOUT = parseInt(ACTIVITY_TIMEOUT_ENV, 10);
// const APP_BASE_URL = process.env.REACT_APP_BASE_URL;


const LandingPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, token, isAuthenticated } = useSelector((state) => state.auth);

  // const { accountId, setAccountId, submitAccount, clearAccountData } = useAccount(); 
  // useEffect(() => {
  //   if (!isAuthenticated) {
  //     navigate('/');
  //   } else {
  //     navigate('/viewer?view=drivers');
  //   }
  // }, [isAuthenticated, navigate]);
  const isActive = useActivityStatus(ACTIVITY_TIMEOUT);

  useEffect(() => {
    if (isActive === false) {
      return;
    }
    console.log("APP_BASE_URL:", APP_BASE_URL);
    // const token = decodeURIComponent(window.location.href.replace(window.location.origin + "/", ""));
    console.log("token verify called");
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get('t');
    console.log("tokenFromUrl", tokenFromUrl);

    const verifyToken = async (tokenToVerify) => {
      if (!tokenToVerify) {
        dispatch(clearAccountData());
        dispatch(logOut());
        navigate('/');
        return;
      }
      setIsLoading(true);
      setError(null);
      try {
        const response = await fetch(APP_BASE_URL + `/api/verify/token/${tokenToVerify}`);
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || `HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("Fetched Data:", data);
        if (data && typeof data === "object" && ("verify" in data)) {
          if (data.verify === false) {
            localStorage.removeItem("token");
            dispatch(clearAccountData());
            dispatch(logOut());
            navigate('/');
            return;
          }
          console.log("data.user: ", data.user);
          console.log("data.user.accout_id: ", data.user.account_id);
          if (data.user && data.user.account_id) {
            console.log("dispatch user: ", data.user);
            if (tokenToVerify) {
              localStorage.setItem("token", tokenToVerify)
            }
            dispatch(setCredentials({ user: data.user, token: tokenToVerify }));
            dispatch(setAccountId(data.user.account_id));
            navigate('/viewer?view=drivers');
          }
        }
      } catch (err) {
        console.error("Error during token verification:", err);
        setError("Failed to verify token. Please try again.");
        localStorage.removeItem("token");
        dispatch(clearAccountData());
        dispatch(logOut());
        navigate('/');
      } finally {
        setIsLoading(false);
      }
    };

    let tokenToUse = tokenFromUrl;

    if (!tokenToUse) {
      // If no token in URL, check local storage
      tokenToUse = localStorage.getItem("token");
      console.log("tokenFromLocalStorage", tokenToUse);
    }
   
    if (!tokenToUse && isAuthenticated && token) {
      // Fallback to Redux auth state if still no token
      tokenToUse = token;
      console.log("tokenFromAuthState", tokenToUse);
    }
  
    verifyToken(tokenToUse);
    return () => { };

  }, [navigate, dispatch, location.search, APP_BASE_URL, isAuthenticated, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(APP_BASE_URL + '/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      if (data.success) {
        if (data.token) {
          localStorage.setItem("token", data.token)
        }
        dispatch(setCredentials({ user: data.user, token: data.token }));
        dispatch(setAccountId(data.user.account_id));
        navigate('/viewer?view=drivers');
      } else {
        setError(data.detail || 'Login failed. Please check your credentials.'); // <--- MODIFIED: Display backend error message
      }
    } catch (error) {
      setError(error.message || 'Something wrong. Try again');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-2 bg-gray-50">
      <div className="max-w-md w-full space-y-2">
        {/* Logo and Header */}
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center">
            <img src={logo} alt="Logo" />
          </div>

          <p className=" text-gray-600">MVR Analysis and Driver Compliance</p>
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-xl shadow-lg p-8 transition-all duration-300 hover:shadow-xl">
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Login <span className="text-sm font-normal text-gray-500">(Use 4safedrivers Business Account)</span></h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
                User Name
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                placeholder="Username"
                required
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                placeholder="Password"
                required
              />
            </div>

            {error && (
              <div className="text-red-500 text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium py-3 px-4 rounded-lg transition-all duration-200 hover:from-blue-700 hover:to-purple-700 flex items-center justify-center disabled:opacity-70"
            >
              {isLoading ? (
                <span className="flex items-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Loading...
                </span>
              ) : (
                <span className="flex items-center">
                  Login
                  <MdArrowForward className="ml-2" />
                </span>
              )}
            </button>
          </form>

          <div className="mt-6 pt-5 border-t border-gray-100 text-center">
            <p className="text-sm text-gray-500">
              Don't have an account? <a href="#" className="text-blue-600 hover:text-blue-800 font-medium">Contact Sales</a>
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-sm text-gray-500">
          <p>© {new Date().getFullYear()} DriverSure. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;